import React, { FC } from 'react';

const Main: FC = () => {
  window.location.pathname = '/volunteers';

  return <></>;
};

export default Main;
